import { useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

// 차트 크게/작게 토글(2026-07-18 피드백 — "거시적으로 보거나 세부적으로 보고 싶을 수도").
// 우상단 아이콘을 누르면 같은 차트가 두 배 가까운 높이로 펼쳐진다 — 보고할 때, 미세한
// 추세를 볼 때 용도. 모든 추이 차트가 이 프레임을 공유해 동작·아이콘 위치가 동일하다.
export default function ChartFrame({ base, tall, children }) {
  const [big, setBig] = useState(false);
  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setBig((b) => !b)}
        title={big ? "작게 보기" : "크게 보기"}
        className="absolute right-0 top-0 z-10 flex h-7 w-7 items-center justify-center rounded-lg bg-ink-50 text-ink-400 hover:bg-ink-100 hover:text-ink-700"
      >
        {big ? <Minimize2 className="h-3.5 w-3.5" /> : <Maximize2 className="h-3.5 w-3.5" />}
      </button>
      <div className={`w-full transition-[height] duration-200 ${big ? tall : base}`}>{children}</div>
    </div>
  );
}
